<template>
  <van-popup v-model="show" get-container="#app" round>
    <div class="pop-outer">
      <div class="pop-header">
        归寝详情
        <div class="close-btn" @click="closePop">
          <van-icon name="cross" />
        </div>
      </div>
      <div class="info-row1">
        <div class="row1-img">
          <img v-if="popData.inOutPhotos || popData.avater" :src="popData.inOutPhotos || popData.avater" style="height: 100%;width: 100%;" @click="previewImg(popData.inOutPhotos || popData.avater)" />
          <img v-else src="./user.png" style="height: 100%;width: 100%;" />
        </div>
        <div class="row1-info">
          <div>姓名：{{ popData.name }}</div>
          <div>性别：{{ popData.gender == '' ? '无' : popData.gender == 1 ? '女' : '男' }}</div>
          <div>班级：{{ popData.className }}</div>
        </div>
      </div>
      <div class="info-row2">
        <div style="display: flex;">
          <div style="flex-shrink: 0;">识别地点：</div>
          <div>{{ popData.inOutLocation ? popData.inOutLocation : '暂无识别信息' }}</div>
        </div>
        <div style="display: flex;">
          <div style="flex-shrink: 0;">识别时间：</div>
          <div>{{ popData.inOutTime ? formatTime(popData.inOutTime, 'YYYY-MM-DD HH:mm:ss') : '暂无识别信息' }}</div>
        </div>
        <div style="color: #E30808;position: relative;">
          <div style="display: flex;line-height: 1rem;margin-top: 0.8rem;" v-if="popData.leaveListVMS && popData.leaveListVMS.length">
            <div>请假时段：</div>
            <div class="leave-list">
              <div v-for="date in popData.leaveListVMS">
                <!-- <div>{{ formatTime(date.beginDate, 'YY-MM-DD HH:mm') }}~{{ formatTime(date.endDate, 'YY-MM-DD HH:mm') }}<span v-if="date.eventType !== 2" style="margin-left: 1rem;">{{ date.eventType === 0 ? '请假离校' : date.eventType === 1 ? '请假归寝' : '' }}</span></div> -->
                <div>{{ formatTime(date.beginDate, 'YY-MM-DD HH:mm') }}~{{ formatTime(date.endDate, 'YY-MM-DD HH:mm') }}</div>
                <div v-if="date.eventType !== 2">{{ date.eventType === 0 ? '请假离校' : date.eventType === 1 ? '请假归寝' : '' }}</div>
              </div>
            </div>
          </div>
          <template v-else>
            <template v-if="formInfo.continuedDay">
              <div v-if="formInfo.tolayStatus == 0 || formInfo.tolayStatus == 2 || formInfo.tolayStatus == 5 || formInfo.tolayStatus == 8">久进未出{{ formInfo.continuedDay }}天</div>
              <div v-if="formInfo.tolayStatus == 1 || formInfo.tolayStatus == 3 || formInfo.tolayStatus == 6 || formInfo.tolayStatus == 7">久出未进{{ formInfo.continuedDay }}天</div>
            </template>
          </template>
        </div>
        <div class="dispose-history" v-if="historyList.length > 0">
          <div class="history-title">在寝处理记录</div>
          <div class="history-list">
            <div class="history-item" v-for="item in historyList">
              <div class="history-left">
                <div class="item-img">
                  <img src="./clock.png" />
                </div>
                <div class="item-line">
                  <div class="line-dashed"></div>
                </div>
              </div>
              <div class="history-right">
                <div class="item-time">
                  <span>{{ formatTime(item.signTime, 'HH:mm MM-DD') }}</span>
                  <span>{{ item.signUserName }}-{{ item.signUserOrgName }}</span>
                </div>
                <div class="item-user">
                  <span>变更状态为{{ statusList[item.signStatus] }}</span>
                  <span v-if="item.reason" @click="(showReason = true), (reason = item.reason)" style="color: #3775ffff;">查看原因</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pop-button">
        <!-- <div class="check-button" @click="check()">{{ popData.status == 0 || popData.status == 2 ? '离寝' : '归寝' }}补签</div> -->
        <div class="check-button" @click="disposeStatus()">在寝状态处理</div>
      </div>
      <div class="type-img">
        <img v-if="(formInfo.leaveListVMS && formInfo.leaveListVMS.length) || popData.status == 4 || popData.status == 10 || popData.status == 11" src="./dorm-absence.png" />
        <template v-else>
          <img v-if="popData.status == 0 || popData.status == 2 || popData.status == 5 || popData.status == 8" src="./dorm-in.png" />
          <img v-if="popData.status == 1 || popData.status == 3 || popData.status == 6 || popData.status == 7" src="./dorm-notin.png" />
        </template>
      </div>
    </div>
    <disposePop ref="disposePopRef" @confirm="closePop"></disposePop>
    <van-popup v-model="showReason" get-container="#app" round>
      <div class="pop-reason-outer">
        <div class="pop-header">
          处理原因
          <div class="close-btn" @click="showReason = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div style="margin-top: 1rem;">
          {{ reason }}
        </div>
      </div>
    </van-popup>
  </van-popup>
</template>

<script>
import moment from 'moment';
import { ImagePreview } from 'vant';
import disposePop from './disposePop.vue';
export default {
  components: {
    disposePop
  },
  data() {
    return {
      statusList: ['在寝', '不在寝', '晚归', '未归', '请假', '正常归寝', '正常离寝', '迟离', '未离', '误识别记录', '请假在寝', '请假离校'],
      historyList: [],
      show: false,
      findDate: '',
      timeType: '',
      // 是否归寝信息
      formInfo: {},
      // 人员信息
      popData: {},
      showReason: false,
      reason: ''
    };
  },
  methods: {
    open(data, date, timeType) {
      this.show = true;
      this.findDate = date;
      this.formInfo = data;
      this.timeType = timeType;
      this.popData = {};
      this.historyList = [];
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });

      this.axios
        .post(`student-consumer/api/dormitory/getDormDataByDateAndUserId`, {
          findDate: this.findDate,
          userId: this.formInfo.userId,
          dormOrganId:this.formInfo.dormOrganId,
          timeType: this.timeType
        })
        .then(res => {
          if (res.code == 200) {
            loading.clear();
            this.popData = res.data;
            this.historyList = res.data.busRestockSignRecordListVMS ? res.data.busRestockSignRecordListVMS : [];
          } else {
            this.$toast.fail({ getContainer: '#app', message: res.msg });
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },
    closePop(e) {
      if (e == 'refresh') {
        this.$emit('refresh');
      }
      this.show = false;
      setTimeout(() => {
        this.popData = {};
      }, 500);
    },
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl]
      });
    },
    disposeStatus() {
      this.$refs.disposePopRef.open({ findDate: this.findDate, userId: this.formInfo.userId, timeType: this.popData.timeType, status: this.popData.status,dormOrganId:this.formInfo.dormOrganId });
    },
    // check() {
    //   const loadingToast = this.$toast.loading({
    //     duration: 0,
    //     message: '补签中...',
    //     forbidClick: true,
    //     getContainer: '#app'
    //   });
    //   let singDate = '';
    //   let rightDate = moment().format('HH:mm:ss');
    //   singDate = `${this.findDate} ${rightDate}`;
    //   this.axios
    //     .post(`student-consumer/nonInductive/attendance/dormSignInPlatform`, {
    //       signDate: singDate,
    //       userId: this.formInfo.userId,
    //       direction: this.popData.status == 0 || this.popData.status == 2 ? 2 : 1
    //     })
    //     .then(res => {
    //       if (res.code == 200) {
    //         this.show = false;
    //         loadingToast.clear();
    //         this.$toast.success({ getContainer: '#app', message: '补签成功' });
    //         this.$emit('refresh');
    //       } else {
    //         this.$toast.fail({ getContainer: '#app', message: res.msg });
    //       }
    //     })
    //     .catch(e => {
    //       this.$toast.fail({ getContainer: '#app', message: e.msg });
    //     });
    // },
    formatTime(time, format) {
      if (time) {
        return moment(time).format(format);
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('./loading.scss');
.pop-reason-outer {
  color: #333;
  padding: 0 1.5rem 1.5rem 1.5rem;
  width: 90vw;
  position: relative;
  font-size: 0.875rem;
  background: url('./popinfo-bg.png');
  background-size: 100% 100%;
  .pop-header {
    padding: 1rem 0 0.7rem 0;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: bold;
    .close-btn {
      position: absolute;
      color: #999999;
      right: -0.5rem;
      top: 1rem;
      font-size: 1rem;
    }
  }
}
.pop-outer {
  color: #333;
  padding: 0 1.5rem;
  padding-bottom: 2rem;
  width: 90vw;
  position: relative;
  font-size: 0.875rem;
  background: url('./popinfo-bg.png');
  background-size: 100% 100%;
  .info-row1 {
    display: flex;
    .row1-img {
      width: 4.5rem;
      height: 6rem;
      padding: 0.5rem;
      // background-color: #ccc;
    }
    .row1-info {
      padding-left: 3vw;
      line-height: 2rem;
    }
  }
  .info-row2 {
    // margin-top: 0.5rem;
    line-height: 2rem;
    & > * {
      // margin-top: 1rem;
    }
  }
  .pop-button {
    margin-top: 1rem;
    text-align: center;
    .check-button {
      // background-color: #1989fa;
      border: 1px solid #1989fa;
      // display: inline-block;
      color: #1989fa;
      padding: 0.5rem 1.5rem;
      border-radius: 2rem;
    }
  }
  .pop-header {
    padding: 1rem 0 0.7rem 0;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: bold;
    .close-btn {
      position: absolute;
      color: #999999;
      right: -0.5rem;
      top: 1rem;
      font-size: 1rem;
    }
  }
  .type-img {
    width: 6.5rem;
    height: 6.5rem;
    position: absolute;
    right: 0.5rem;
    top: 6rem;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
.leave-list {
  flex: 1;
  max-height: 8rem;
  overflow: auto;
  & > div:not(:first-child) {
    padding-top: 0.5rem;
  }
}
.dispose-history {
  .history-title {
    position: relative;
    // font-size:1rem;
    // padding: 0.1rem 0.1rem 0.1rem 0.8rem;
    padding-left: 0.8rem;
    margin-bottom: 0.5rem;
    &::before {
      display: block;
      content: '';
      width: 0.3rem;
      height: 60%;
      background-color: #3775ffff;
      position: absolute;
      border-radius: 0.15rem;
      left: 0;
      top: 20%;
    }
  }
  .history-list {
    max-height: 8rem;
    overflow: auto;
    padding-right: 1rem;
    .history-item {
      display: flex;
      .history-left {
        width: 1rem;
        .item-img {
          line-height: 1rem;
          height: 1rem;
          width: 1rem;
          img {
            height: 100%;
            width: 100%;
          }
        }
        .item-line {
          width: 1rem;
          height: 2rem;
          display: flex;
          justify-content: center;
          .line-dashed {
            width: 1px;
            height: 2rem;
            border-left: 1px dashed #3775ffff;
          }
        }
      }
      .history-right {
        flex: 1;
        padding-left: 0.5rem;
        .item-time {
          font-size: 0.875rem;
          line-height: 1rem;
          display: flex;
          justify-content: space-between;
        }
        .item-user {
          color: #666666ff;
          font-size: 0.8rem;
          line-height: 2rem;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .history-item:last-child {
      .line-dashed {
        display: none;
      }
    }
  }
}
</style>
